module.exports = {
  title: 'Yoko Takahashi en Costa Rica',
  description: 'New Genesis Latam Tour. Yoko Takahashi en el Palacio de los Deportes, Heredia, el sábado 21 de noviembre. Apertura 12:00 md. Preventa activa.',
  keywords: 'yoko takahashi, costa rica, new genesis, latam tour, a cruel angels thesis, palacio de los deportes, heredia, portal pop culture',
  url: 'https://imperioanimecr.com/yoko/',
  twitter: '@portalpopculture.events',
  seoImage: 'https://imperioanimecr.com/yoko/images/yoko-poster.jpg',
  color: '#07010f'
};
